module.exports = __webpack_public_path__ + "media/images/pages/img_digest_area_03-c17f33fe2c87d6a8f8dabb61c99e0ede.jpg";